/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import NewTreatmentModal from './NewTreatmentModal/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/New/TreatmentCard/Treatment/Empty"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Empty.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-4PwO0': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--ml-2-4PwO0': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 size="small"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, './NewTreatmentModal/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, './NewTreatmentModal/Content'))}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Add New Treatment"
/>
)}
</TysiaButton>
</div>
<NewTreatmentModal
  viewPath={`${viewPath}/NewTreatmentModal`}
/>
{children}
</React.Fragment>)
}